import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "alert alert-light show fade border screen-size-toolbar p-1 ms-2 d-flex flex-column" }
const _hoisted_2 = { class: "d-flex flex-column" }
const _hoisted_3 = { class: "input-group input-group-sm d-flex mb-1 flex-fill" }
const _hoisted_4 = { class: "input-group-text col" }
const _hoisted_5 = {
  class: "mx-auto",
  id: "current-size"
}
const _hoisted_6 = { class: "d-flex alight-items-center" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = {
  class: "progress border col",
  style: {"height":"25px"}
}
const _hoisted_9 = ["aria-valuenow"]
const _hoisted_10 = { class: "small mx-1 text-nowrap my-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", null, [
      _createElementVNode("button", {
        type: "button",
        class: "btn-close btn-sm float-end mb-2",
        "aria-label": "Close",
        "data-togle": "collapse",
        "data-target": ".screen-size-toolbar",
        "data-bs-dismiss": "alert"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"input-group input-group-sm d-flex mb-1 flex-fill\"><div class=\"input-group-text font-monospace col\"><span class=\"mx-auto\" id=\"min-size\"></span></div><div class=\"input-group-text font-monospace col\"><span class=\"mx-auto\" id=\"current-name\"></span></div><div class=\"input-group-text font-monospace col\"><span class=\"mx-auto\" id=\"max-size\"></span></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.windowWidth) + "px", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "progress-bar progress-bar-striped bg-info",
              role: "progressbar",
              style: _normalizeStyle({ width: _ctx.widthPercentage + '%' }),
              "aria-valuenow": _ctx.widthPercentage,
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.widthPercentage) + " % ", 1)
            ], 12, _hoisted_9)
          ])
        ])
      ])
    ])
  ]))
}